import { memo } from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { processReturn } from 'actions/tools/CommonInterface/Returns/AsyncReturnActions';

const DTProcessReturnThenSendMacro = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processReturn());

  return (
    <DTCopyTextSendMacroView
      buttonText={'PROCESS RETURN'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to process the selected return for the customer.'}
      customErrorMessage={'There was a problem processing the return.'}
    />
  );
};

export default memo(withConfirmation(DTProcessReturnThenSendMacro));
